.copy-link-container {
  text-align: left;
}
.copy-link-container .copy-link-col {
  text-align: left;
}
.copy-link-container .copy-link {
  margin-top: 4px;
  white-space: unset;
  color: #00bfa5 !important;
  text-decoration: none;
  transition: color 0.15s ease;
}
.copy-link-container .copy-link:hover {
  text-decoration: underline;
}
.copy-link-container .copy-link--copied {
  color: #008289 !important;
  pointer-events: none;
}
.copy-link-container .copy-link--copied i.fa {
  font-size: 12px;
}
.copy-link-container .copy-link--failed {
  color: #f44336 !important;
}
.copy-link-container .message-text {
  padding: 3px 5px;
  font-size: 14px;
  line-height: 1.5;
  display: inline-block;
  margin-top: 4px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL3RtcC9idWlsZF9mNmVhODkyMC9hcHAvamF2YXNjcmlwdC9jb21wb25lbnRzL2NvbW1vbi9Db3B5TGluayIsInNvdXJjZXMiOlsiQ29weUxpbmsuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQTtFQUNFOztBQUVBO0VBQ0U7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7O0FBR0Y7RUFDRTtFQUNBOztBQUVBO0VBQU87O0FBR1Q7RUFDRTs7QUFJSjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyJAdXNlICcuLi8uLi8uLi8uLi9hc3NldHMvc3R5bGVzaGVldHMvY2xvcmEtYm9vdHN0cmFwLXZhcmlhYmxlcycgYXMgdmFycztcblxuLmNvcHktbGluay1jb250YWluZXIge1xuICB0ZXh0LWFsaWduOiBsZWZ0O1xuXG4gIC5jb3B5LWxpbmstY29sIHtcbiAgICB0ZXh0LWFsaWduOiBsZWZ0O1xuICB9XG5cbiAgLmNvcHktbGluayB7XG4gICAgbWFyZ2luLXRvcDogNHB4O1xuICAgIHdoaXRlLXNwYWNlOiB1bnNldDtcbiAgICBjb2xvcjogdmFycy4kcHJpbWFyeS1ncmVlbi1iYXNlICFpbXBvcnRhbnQ7XG4gICAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuICAgIHRyYW5zaXRpb246IGNvbG9yIDAuMTVzIGVhc2U7XG5cbiAgICAmOmhvdmVyIHtcbiAgICAgIHRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lO1xuICAgIH1cblxuICAgICYtLWNvcGllZCB7XG4gICAgICBjb2xvcjogdmFycy4kcHJpbWFyeS1ncmVlbi1kYXJrICFpbXBvcnRhbnQ7XG4gICAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcblxuICAgICAgaS5mYSB7IGZvbnQtc2l6ZTogMTJweDsgfVxuICAgIH1cblxuICAgICYtLWZhaWxlZCB7XG4gICAgICBjb2xvcjogdmFycy4kcHJpbWFyeS1yZWQtYmFzZSAhaW1wb3J0YW50O1xuICAgIH1cbiAgfVxuXG4gIC5tZXNzYWdlLXRleHQge1xuICAgIHBhZGRpbmc6IDNweCA1cHg7XG4gICAgZm9udC1zaXplOiAxNHB4O1xuICAgIGxpbmUtaGVpZ2h0OiAxLjU7XG4gICAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICAgIG1hcmdpbi10b3A6IDRweDtcbiAgfVxufVxuIl19 */